import { Box, Button } from '@mui/material'
import { useEffect, useState } from 'react';
import { MenuIcon } from '../../../../../core/icon/__refactored/Icon';
import { env } from '../../../../../core/Env';
import { rqx } from '../../../../../core/request/API';
import { SnakeLoader } from '../../../../../core/loader/SnakeLoader';
import { MediaLoader } from '../../../../../core/loader/MediaLoader';
import { FeatureIdState } from '../../../toolUsage/global/GlobalFcn';
import { CreateFeatureLogs } from '../../../../../core/request/Global';

function getOrdinal(n) {
    const s = ["th", "st", "nd", "rd"],
          v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

export const Quiz = ({openWidth, wideHandler, information_state, uid, nav, cid, getNextIncompleteStep, tool_state}) => {
    let urlParams = new URLSearchParams(window.location.search);
    const [ans, setAns] = useState([])
    const [act, setAct] = useState(false)
    const [tc, setTC] = useState()
    const [selectCategory, setselectCategory] = useState([])
    const [correctAnswers, setCorrectAnswers] = useState(0);
    const [validationError, setValidationError] = useState('');
    const trainingId = urlParams.get('id');

    const __init = async (trainingId) => {
        const courseData = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_view_course`, { course_id: cid, company_id: tool_state.cinfo.data[0].company_id });
        const allTrainingIds = courseData[0].trainings.map(t => t.training_id).join(',');
        setTC(courseData);
    
        const init = await rqx.get(`<<tool>>/${env()}/biz_exam/user_read_Quiz`, { training_id:urlParams.get('id'), ref:'course' });
        information_state.exam.set(init);
    
        const progress = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_check_trainings`, {
            training_id: allTrainingIds,
            user_id: uid,
            ref: 'course',
            course_id: cid,
            company_id: tool_state.cinfo.data[0].company_id
        });
    
        const tContent = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_training_content`, {
            training_id: allTrainingIds,
            ref: 'course'
        });
    
        // ✅ Save progress to state
        const progressByTraining = {};
        progress.forEach(p => {
            if (!progressByTraining[p.training_id]) progressByTraining[p.training_id] = [];
            progressByTraining[p.training_id].push(p);
        });
        information_state.trainingProgress.set(progressByTraining);
    
        // ✅ Save tContent to state
        const thisContent = tContent.find(t => t.training_id === trainingId);
        information_state.tc.set({
            ...information_state.tc.data,
            pretest: thisContent?.pretest_id !== null ? 1 : null,
            quiz: thisContent?.quiz_id !== null ? 1 : null,
            posteval: thisContent?.post_evaluation_id !== null ? 1 : null
        });
    
        // ✅ Use helper to determine where to go next
        const nextStep = getNextIncompleteStep(trainingId, tContent, progress);
    
        if (nextStep) {
            return nav.push(`/take-course/${nextStep}?id=${trainingId}&cid=${cid}`);
        }
    
        // ✅ All steps done for this training → go to next one
        const currentIndex = allTrainingIds.findIndex(id => id === trainingId);
        const nextTrainingId = allTrainingIds[currentIndex + 1];
    
        if (nextTrainingId) {
            return nav.push(`/take-course/video-lesson?id=${nextTrainingId}&cid=${cid}`);
        } else {
            console.log("🎉 All trainings completed!");
            // nav.push('/course-complete');
        }
    };
    
    useEffect(() => {
        information_state.test.set({...information_state.test.data, name:'Quiz'});
        __init(trainingId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trainingId]);
    
    
    const handleClick = (e, id, q, k, kk, choice, correct) => {
        e.preventDefault()
        if (act !== true) {
            const isCorrect = correct === choice ? 1 : 0 
            let a = [...ans]
            a[k] = {question_id: id, question: q, ans: choice, answer_status: isCorrect }
            setAns(a)
            let b = [...selectCategory]
            b[k] = kk
            setselectCategory(b)
            let err = [...validationError]
            err[k] = false
            if(correct === choice) {
                setCorrectAnswers((prevCount)=> prevCount + 1)
            }
        }
    }
    
    const handleSubmit = () => {
        const correctCount = ans.filter(a => a && a.answer_status === 1).length;
        setCorrectAnswers(correctCount);

        const allAnsweredStatus = information_state.exam.data.exam.map((q, k) => {
            if (ans[k] && ans[k].ans !== '') {
                return false;
            } else {
                return true;
            }
        });

        if (allAnsweredStatus.includes(true)) {
            setValidationError(allAnsweredStatus);
            return;
        } else {
            setValidationError(allAnsweredStatus);
        }
        let passedfailed;
        if(parseFloat(correctAnswers/(information_state.exam.data.exam.length/100).toFixed(2)) >= 80) {
            passedfailed = 1
        } else {
            passedfailed = 0
        }
        const data ={
          user_id:uid,
          exam_type:2,
          progress_status:passedfailed,
          training_id:urlParams.get('id'),
          course_id: cid,
          data:ans,
          company_id: tool_state.cinfo.data[0].company_id
        }
        _init(data)
    }

    const _init = async(data)=>{
        let res = { 
            aid: tool_state.__SESSION.data.ainfo.aid,
            path: `${FeatureIdState('assessment')}->2`,
            feature_id: FeatureIdState('assessment'),
            feature_name: 'assessment-quiz',
            tid: parseInt(process.env.REACT_APP_TID_BIZ),
            company_id: tool_state.cinfo.data[0].company_id,
            action: 1,
        } 
        await CreateFeatureLogs(res)
        // eslint-disable-next-line
        await rqx.post(`<<tool>>/${env()}/biz_exam/user_update_status`, data)
        const init = await rqx.post(`<<tool>>/${env()}/biz_exam/exam_create`, data)
        if (init.message === 'success') {
            setAct(true)
        } else {
            console.log('error')
            // setAct(true)
        }
    }
    const handleProceed = () => {
        nav.push(`/biz/take-course/post-evaluation?id=${trainingId}&cid=${cid}`)
    }

    const handleNextTraining = async(id) => {
        let data = {
            user_id:uid,
            training_id:trainingId,
            course_id: cid,
            ref: 'course',
            company_id: tool_state.cinfo.data[0].company_id
        }
        const comp = await rqx.post(`<<tool>>/${env()}/biz_exam/exam_update_EOC`, data)
        if (comp.message === 'success'){
            nav.push(`/take-course/pretest?id=${id}&cid=${cid}`)
            information_state.prog.set(...information_state.prog, {pretest: 0, vl:0, quiz:0, posteval:0})
            __init()
        }
    }
    const handleRetake = () => {
        setCorrectAnswers(0)
        setselectCategory([])
        setAns([])
        setAct(false)
    }
    return (
        <Box p="40px" display="flex" flexDirection="column" width="100%" height="100%">
            <Box width="100%" height="100%">
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box fontSize={14} fontWeight={400} lineHeight="22.65px">Direction: Choose the letter of the correct answer.</Box>
                    { !openWidth.data && (
                        <Box display="flex" className='c-pointer' onClick={wideHandler}>
                            <MenuIcon />
                            <Box fontSize={14} fontWeight={600} lineHeight="22.65px" color="#1893F1" ml="12px">Show menu</Box>
                        </Box>
                        )
                    }
                </Box>
                { act === true && (
                    <Box border="1px solid #E5EBF6" bgcolor="#1893F1" borderRadius="8px" p="24px 16px 24px 16px" mt="24px" width="100%">
                        <Box fontSize="P-300" lineHeight="23px" color="#E3F2FD">You have reached {correctAnswers} of {information_state.exam.data.exam.length} point(s), ({parseFloat(correctAnswers/(information_state.exam.data.exam.length/100).toFixed(2))}%)</Box>
                    </Box>
                )}
                {act ? (() => {
                    const currentTrainingId = parseInt(urlParams.get('id'));
                    const trainings = tc[0]?.trainings || [];
                    const currentIndex = trainings.findIndex(t => t.training_id === currentTrainingId);
                    const nextTraining = trainings[currentIndex + 1];
                    const postEvalAvailable = information_state.tc.data.posteval === 1;
                    const quizPassed = parseFloat((correctAnswers / information_state.exam.data.exam.length) * 100).toFixed(2) >= 80;
                    return (
                        <Box border="1px solid #E5EBF6" borderRadius="8px" p="24px" mt="24px" width="100%"
                             bgcolor={quizPassed ? "#F5F8FF" : "#FFEBEE"}>
                            {quizPassed ? (
                                postEvalAvailable ? (
                                    <>
                                        <Box fontSize="P-400" color="#000">🎉 Congratulations! You passed the quiz.</Box>
                                        <Box mt="8px" fontSize="P-300" color="#1893F1">Take the Post Evaluation and generate your certificate.</Box>
                                    </>
                                ) : nextTraining && (
                                    <>
                                        <Box fontSize="P-400" color="#000">Congratulations! You passed the quiz. You are one step closer on becoming Extraordiany Professional.</Box>
                                        <Box fontSize="P-400" color="#1893F1" my={3}>Continue to the next training.</Box>
                                            <Box display="flex" width="100%" bgcolor="#fff" justifyContent="space-between" borderRadius={6} p="12px">
                                                <Box display="flex" alignItems="center" >
                                                    <MediaLoader image={nextTraining.image} width="120px" height="64px" />
                                                    <Box lineHeight="19px" fontSize="14px" fontWeight={400} ml={1} sx={{width: '100%', maxWidth:'200px',whiteSpace: 'nowrap',textOverflow: 'ellipsis', overflow: 'hidden', }} >{nextTraining.title}</Box>
                                                </Box>
                                                <Box display="flex" alignItems="center">
                                                    <Box lineHeight="19px" fontSize="12px" fontWeight={400} mr={1}>Training • {nextTraining.duration_text}</Box>
                                                    <Button variant="contained" onClick={() => handleNextTraining(nextTraining.training_id)}>
                                                        Go to Next Course
                                                    </Button>
                                                </Box>
                                            </Box>
                                    </>
                                )
                            ) : (
                                <>
                                    <Box fontSize="P-400" color="#000">❌ Sorry, you didn’t pass the quiz.</Box>
                                    <Box mt="8px" fontSize="P-300" color="#000">You still have a chance to become extraordinary.</Box>
                                </>
                            )}
                        </Box>
                    );
                })()
                    : (
                        information_state.exam.data !== undefined ? (
                            information_state.exam.data.exam.map((q, k) => (
                                <Box key={k} border="1px solid #E5EBF6" borderRadius="6px" p="24px" mt="24px" width="100%">
                                    <Box fontSize={14} fontWeight={600} lineHeight="22px">Question no. {k + 1}</Box>
                                    <Box fontSize={14} fontWeight={400} lineHeight="22px" mt="24px" mb="8px">{q.question}</Box>
                                    {
                                        q.choices.map((v, kk)=>(
                                            <Box key={kk} display='flex' width="100%" mt="16px" onClick={(e)=>handleClick(e, q.question_id, q.question, k, kk, v.key, q.correct)} >
                                                <Box display="flex" alignItems="center" width="100%" sx={{textAlign: 'start', '&:hover': {'& > div:first-of-type': {bgcolor: '#E3F2FD',}, },}}>
                                                    <Box border="1px solid #E5EBF6" borderRadius="100%" bgcolor= { act === false ? (selectCategory[k] === kk && '#E3F2FD') : ( selectCategory[k] === kk && q.correct === ans[k].ans ? '#E8F5E9' : ( selectCategory[k] === kk && q.correct !== ans[k].ans ? '#FFEBEE' : ( q.correct === v.key && '#E8F5E9' ) ) )}  color= { act === false ? (selectCategory[k] === kk && '#1893F1') : ( selectCategory[k] === kk && q.correct === ans[k].ans ? '#008F5D' : ( selectCategory[k] === kk && q.correct !== ans[k].ans ? '#FA3E3E' : ( q.correct === v.key && '#008F5D' ) ) ) } p="8px 12px 8px 12px" >
                                                        <Box fontSize={14} fontWeight={600}>{v.key}</Box>
                                                    </Box>
                                                    <Box border="1px solid #E5EBF6" borderRadius="6px" bgcolor= { act === false ? (selectCategory[k] === kk && '#E3F2FD') : ( selectCategory[k] === kk && q.correct === ans[k].ans ? '#E8F5E9' : ( selectCategory[k] === kk && q.correct !== ans[k].ans ? '#FFEBEE' : ( q.correct === v.key && '#E8F5E9' ) ) )}  color= { act === false ? (selectCategory[k] === kk && '#1893F1') : ( selectCategory[k] === kk && q.correct === ans[k].ans ? '#008F5D' : ( selectCategory[k] === kk && q.correct !== ans[k].ans ? '#FA3E3E' : ( q.correct === v.key && '#008F5D' ) ) ) }  className='choices' p="12px" width="100%" ml="16px" >
                                                        <Box fontSize={14} fontWeight={600}>{v.value}</Box>
                                                    </Box>
                                                </Box>
                                            </Box>
    
                                        ))
                                    }
                                </Box>
                            ))
                        ) : (
                            <Box display="flex" justifyContent="center">
                                <SnakeLoader size="0.7rem" bg="#0170EC" distance="0.3rem" />
                            </Box>
                        )
                    )
                }
                <Box display="flex" justifyContent="flex-end" my="24px">
                    {
                        act === true ? (()=>{
                            const currentTrainingId = parseInt(urlParams.get('id'));
                            const trainings = tc[0]?.trainings || [];
                            const currentIndex = trainings.findIndex(t => t.training_id === currentTrainingId);
                            const nextTraining = trainings[currentIndex + 1];
                            const postEvalAvailable = information_state.tc.data.posteval === 1;
                            const quizPassed = parseFloat((correctAnswers / information_state.exam.data.exam.length) * 100).toFixed(2) >= 80;
                            
                            return (
                                (quizPassed === true ? (
                                    postEvalAvailable && (
                                        <>
                                           <Box component={Button} onClick={(e) => handleProceed(e)} variant='contained'>Next</Box>
                                        </>
                                    )
                                ) : (
                                    <>
                                        <Box component={Button} onClick={(e) => handleRetake(e)} variant='contained'>Retake</Box>
                                    </>
                                ))
                            )
                        })() :(
                                <Box component={Button} onClick={(e) => handleSubmit(e)} variant='contained'>Submit</Box>
                        )
                    }
                </Box>
            </Box>
        </Box>
    )
}
